<template lang="html">
  <div>
  <div class="" v-bind:id="id" v-if="hasConfig  ">
    <!-- POP-UP INPUT filter -->
    <div :class="showInputFilter? 'is-active':''" class="modal">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="notification mx-4">
          <button class="delete" @click="showFilterPopUp(columnFilter[0])"></button>
          <b>Filter</b>
          <div class="is-flex mt-4">
            <input type="text" class="input is-small is-rounded" v-model="inputFilter" placeholder="Filter">
            <i class="fas fa-lg fa-circle-arrow-right is-align-content-center ml-2" @click="search()"></i>
          </div>
        </div>
      </div>
    </div>

    <div v-for="r of config.remindersId">
      <component v-if="r" v-bind:is="'bulmaReminder'" v-bind:id="r"></component>
    </div>
    
    <div class="is-justify-content-space-between mb-3 is-flex-tablet">
      <div v-if="config.title"><h1 class="title is-5 pr-1 pt-1">{{ config.title }}</h1></div>

      <div v-if="!config.simpleTable" class="" :class="showInput ? 'is-flex-tablet':'is-flex'">
        <!-- SEARCH -->
        <div class="field has-addons mb-0 py-1">
          <div v-if="showInput" class="control">
            <input type="text" class="input is-small is-rounded" v-model="inputSearch" placeholder="Search" @input="search()">
          </div>
          <div class="control">
            <button class="button is-rounded is-small" @click="toggleSearch()">
              <span class="icon"><i class="fas fa-magnifying-glass"></i></span>
            </button>
          </div>
        </div>

        <div class="field is-flex is-align-items-baseline py-1">
          <!-- ADD -->
          <button v-if="canInsert" class="button is-rounded is-small">
            <span class="icon" v-on:click="showAddRecord()"><i class="fas fa-plus"></i></span>
          </button>

          <!-- RELOAD -->
          <button class="button is-rounded is-small"> <span class="icon" v-on:click="loadRows()"><i class="fas fa-rotate-right"></i></span> </button>

          <!-- filters -->
          <button v-if="searchableFields" class="button is-rounded is-small" @click="showFiltri = !showFiltri" :class="{ 'is-link' : $store.state.advancedFilteringProperties.length > 0, 'is-active':showFiltri}"><span class="icon"><i class="fas fa-filter"></i></span></button>

          <!-- LISTVIEWS -->
          <div class="select is-rounded is-small" v-if="config.lists.length > 1">
            <select v-model="current_list_name" v-on:change="changeList">
              <option v-for="list in listviews" v-bind:key="list.name" v-bind:value="list.name">{{ $t(list.label) }}</option>
            </select>
            <!-- TODO: change my default -->
          </div>
        </div>

      <!-- SORT BY (mobile) -->
      <div v-if="!large_screen && setTableCard" class="field is-flex is-align-items-baseline py-1">
        <div class="select is-rounded is-small">
          <select v-model="orderingColumn" @change="selectColumnSortOrder()">
            <option value="" selected>Sort by</option>
            <option v-for="col in current_list_cols" :key="col.fieldname" :value="col.fieldname">{{ col.label }}</option>
          </select>
        </div>

        <button v-if="orderingColumn" class="button is-rounded is-small">
          <span class="icon" v-on:click="selectColumnSortOrder()"><i :class="sortingAsc ? 'fas fa-sort-up': 'fas fa-sort-down'"></i></span>
        </button>

        </div>
      </div>
    </div>

    <!-- <div class="level is-mobile">
      <div class="level-left">
        <div class="level-item">
          <h1 class="title is-5">{{ config.title }}</h1>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">

          SEARCH
          <button class="button is-rounded is-small">
            <span class="icon" v-on:click="search()"><i class="fas fa-magnifying-glass"></i></span>
          </button>

          <div class="field has-addons mb-0">
            <div v-if="showInput" class="control">
              <input type="text" class="input is-small is-rounded" v-model="inputSearch" placeholder="Search" @input="search()">
            </div>
            <div class="control">
              <button class="button is-rounded is-small" @click="toggleSearch()">
                <span class="icon"><i class="fas fa-magnifying-glass"></i></span>
              </button>
            </div>
          </div>

          ADD
          <button v-if="canInsert" class="button is-rounded is-small">
            <span class="icon" v-on:click="showAddRecord()"><i class="fas fa-plus"></i></span>
          </button>

          <button class="button is-rounded is-small"> <span class="icon" v-on:click="loadRows()"><i class="fas fa-rotate-right"></i></span> </button>
          
        </div>
        <div class="level-item">
          <div class="select is-rounded is-small" v-if="config.lists.length > 1">
            <select v-model="current_list_name" v-on:change="changeList">
              <option v-for="list in config.lists" v-bind:key="list.name" v-bind:value="list.name">{{ $t(list.label) }}</option>
            </select>
            TODO: change my default
          </div>
        </div>
      </div>
    </div> -->

    <!-- SEZIONE FILTRI -->
    <div v-if="showFiltri" class="mb-2" style="border: 1px solid;background-color:lightgrey;border-radius:10px"> <!-- possibile colore sfondo #4CA9CA-->
      <div class="columns is-multiline is-gapless p-1 mb-0" v-for="field in searchableFields" v-bind:key="field.name" style="border-bottom: 1px solid">
        <div class="column is-one-third my-1" v-for="f in field" v-bind:key="f.name">
          <bulmaField v-bind:id="f.name" v-bind:data="f"></bulmaField>
        </div>
      </div>

      <div class="column mx-1">
        <div class="columns is-mobile">
          <div class="column is-8-mobile">
            <button class="button is-rounded is-small" @click="resetAdvancedFilters()">RESET</button>
          </div>
          <div class="column">
            <button class="button is-rounded is-small is-active is-link is-pulled-right" @click="loadRows()">SEARCH</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!large_screen && (!setTableCard && !setTableColumnFix)" class="table-container">
      <!-- HEADER -->
      <div class="columns is-multiline is-mobile is-gapless mb-1">
        <div class="column is-text-overflow has-text-weight-bold" v-for="(col,index) in current_list_cols" v-bind:key="col.id" 
          v-bind:style="'text-align:'+align(col.format)" v-bind:class="{'is-hidden':index==0, 'is-one-third':index>0}" >
          <span v-if="canFilter(col.format) && !config.disableFilters" class="icon" v-on:click="showFilterPopUp(col)"><i class="fa-solid fa-filter" :class="{'has-text-link' : col.filtering}"></i></span>
          <span v-on:click="sortOrder(col)">
            {{ col.label }}<span v-if="col.sorting" class="icon"><i :class="'fa-solid fa-sort-'+col.sorting"></i></span>
          </span>
        </div>
      </div>

      <!--  versione columns -->
      <div class="columns is-multiline is-mobile is-gapless" style="border-top: 1px solid;"  v-for="record in current_page_records" v-bind:key="record.id">

        <div class="column is-text-overflow" v-for="(col,index) in current_list_cols" v-bind:key="col.id" v-bind:style="'text-align:'+align(col.format)" v-bind:class="{'is-full':index==0, 'is-one-third':index>0}" >

          <span v-if="index==0 && record.show && config.checkbox" class="mr-1">
            <input :type="config.checkbox == 'multi' ? 'checkbox':'radio'" :id="record.Id" :value="record.Id" v-model="selected_list_id" @change="saveRecords(record)" :disabled="disabledProp"/>
          </span>

          <span v-if="col.format=='link' || col.format=='lookup'">
            <span v-if="config.checkbox" @click="saveRecords(record)">{{ filter( getFieldValue(record, col.fieldname), col.format ) }}</span>
            <span v-else>
              <a href="#" v-on:click.prevent="select(record, col)">
                {{ filter( getFieldValue(record, col.fieldname), col.format ) }}
              </a>
            </span>
          </span>

          <a v-if="col.format=='address'" :href="['https://maps.apple.com/?q=' + getAddress(getFieldValue(record, col.fieldname))]" target="_blank">
            {{ getAddress(getFieldValue(record, col.fieldname)) }}
          </a>

          <a v-if="isActionable(col.format)" v-bind:href="filter( getFieldValue(record, col.fieldname), col.format )" >
            {{ getFieldValue(record, col.fieldname) }}
          </a>

          <button v-if="col.format=='download'" class="button" v-on:click="download(getFieldValue(record, col.fieldname), record)">
            <span class="icon is-small" ><i class="fas fa-download"></i></span>
          </button>
          <span v-if="!isActionable(col.format) && col.format!='link' && col.format!='lookup' && col.format!='hidden' && col.format!='address' && col.format!='download'" >
            <span v-if="col.format=='alert' && record[col.name]" class="icon"><i class="fas fa-bell"></i></span>
            {{ filter( getFieldValue(record, col.fieldname), col.format ) }}
          </span>

        </div>

      </div>
      <!--  versione columns -->      
    </div>

    <div v-if="large_screen || setTableColumnFix" class="table-container">

      <!--  versione table -->
      <table class="table is-narrow">
        <thead>
          <tr>
            <!-- TODO: filter -->
            <!-- TODO: sort -->
            <th v-if="config.checkbox"><input v-if="config.checkbox == 'multi'" type="checkbox" v-model="checkedAllOptions" @click="selectAll(checkedAllOptions)" /></th>
            <th v-for="(col, index) in current_list_cols" class="filterhover" :class="{'first-column-fix' : index == 0 && setTableColumnFix}" v-bind:key="col.id" style="vertical-align:top"  v-on:click="$emit('filter',index)" >
              <!-- <span v-bind:style=" (wrapheader?'white-space: normal':'') " >{{col.label}}</span> -->
              <span v-on:click="sortOrder(col)">
                {{ col.label }}<span v-if="col.sorting" class="icon"><i :class="'fa-solid fa-sort-'+col.sorting"></i></span>
              </span>
              <span v-if="canFilter(col.format) && !config.disableFilters " class="icon hiddenicon" v-on:click="showFilterPopUp(col)"><i class="fa-solid fa-filter" :class="{'has-text-link' : col.filtering}"></i></span>
              <!-- <span v-if="col.filtered" class="icon"><i class="fas fa-filter"></i></span> -->
            </th>
          </tr>
        </thead>
        <tbody>
            <tr v-for="record in current_page_records_desktop" v-bind:key="record.id"><!-- v-on:click="$emit('row',record)" -->
              
              <td v-if="record.show && config.checkbox">
                <input :type="config.checkbox == 'multi' ? 'checkbox':'radio'" :id="record.Id" :value="record.Id" v-model="selected_list_id" @change="saveRecords(record)" :disabled="disabledProp"/>
              </td>

              <td v-if="record.show" v-for="(col, index) in current_list_cols" v-bind:key="col.id" v-bind:style="'text-align:'+align(col.format)" :class="{'is-text-overflow': inOneLine(col.format), 'first-column-fix' : index == 0 && setTableColumnFix}" >

                <a v-if="col.format=='link' || col.format=='lookup'" href="#" v-on:click.prevent="select(record, col)">
                  {{ filter( getFieldValue(record, col.fieldname), col.format ) }}
                </a>

                <a v-if="col.format=='address'" :href="['maps:?q=' + getAddress(getFieldValue(record, col.fieldname))]" target="_blank">
                  {{ getAddress(getFieldValue(record, col.fieldname)) }}
                </a>

                <button v-if="col.format=='download'" class="button" v-on:click="download(getFieldValue(record, col.fieldname), record)">
                  
                  <span class="icon is-small" ><i class="fas fa-download"></i></span>
                  <span>
                    Download
                  </span>
                </button>

                <a v-if="isActionable(col.format)" v-bind:href="filter( getFieldValue(record, col.fieldname), col.format )">
                  {{ getFieldValue(record, col.fieldname) }}
                </a>

                <span v-if="!isActionable(col.format) && col.format!='link' && col.format!='lookup' && col.format!='hidden' && col.format!='address' && col.format!='download'">
                  <span v-if="col.format=='alert' && record[col.name]" class="icon"><i class="fas fa-bell"></i></span>
                  <span v-if="col.format=='comment'">
                    <span v-if="getFieldValue(record, col.fieldname) === true" class="icon has-text-success"><i class="fas fa-comment"></i></span>
                    <span v-else-if="getFieldValue(record, col.fieldname) === false" class="icon has-text-grey-light"><i class="fas fa-comment-slash"></i></span>
                  </span>
                  <span v-else>{{ filter( getFieldValue(record, col.fieldname), col.format ) }}</span>
                </span> 

              </td>

            </tr>
        </tbody>
      </table>
      <!--  versione table -->
    </div>

    <!-- versione cards -->
    <div v-if="!large_screen && setTableCard" v-for="record in current_page_records" v-bind:key="record.id">

      <div class="card my-3">

        <div class="card-content py-1 px-2">

          <div class="content">
            <div class="columns is-mobile is-gapless mb-0 rowcard" v-for="(col,index) in current_list_cols" v-bind:key="col.id" v-bind:style="'text-align:'+align(col.format)">

              <!-- LABEL -->
              <div v-if="index>0" class="column is-3 labelcard" style="word-break: break-word;"><span>{{ col.label }}:</span></div>
                
              <!-- <span v-if="index==0 && record.show && config.checkbox" class="mr-1">
                <input :type="config.checkbox == 'multi' ? 'checkbox':'radio'" :id="record.Id" :value="record.Id" v-model="selected_list_id" @change="saveRecords(record)" :disabled="disabledProp"/>
              </span> -->

              <!-- VALUE -->
              <!-- TODO: sposta click.prevent="select(record, col)" su tutta la card -->
              <div class="column" style="word-break: break-word;">
                <!-- icon -->
                <span v-if="col.icon" class="icon is-small"><i class="fas fa-bold" :class="'fa-'+col.icon"></i></span>

                <span v-if="col.format=='link' || col.format=='lookup'">
                  <span v-if="config.checkbox" @click="saveRecords(record)">{{ filter( getFieldValue(record, col.fieldname), col.format ) }}</span>
                  <span v-else>
                    <a href="#" v-on:click.prevent="select(record, col)">
                      {{ filter( getFieldValue(record, col.fieldname), col.format ) }}
                    </a>
                  </span>
                </span>

                <a v-if="col.format=='address'" :href="['https://maps.apple.com/?q=' + getAddress(getFieldValue(record, col.fieldname))]" target="_blank">
                  {{ getAddress(getFieldValue(record, col.fieldname)) }}
                </a>

                <a v-if="isActionable(col.format)" v-bind:href="filter( getFieldValue(record, col.fieldname), col.format )" >
                  {{ getFieldValue(record, col.fieldname) }}
                </a>

                <button v-if="col.format=='download'" class="button" v-on:click="download(getFieldValue(record, col.fieldname), record)">
                  <span class="icon is-small" ><i class="fas fa-download"></i></span>
                </button>
                <span v-if="!isActionable(col.format) && col.format!='link' && col.format!='lookup' && col.format!='hidden' && col.format!='address' && col.format!='download'" >
                  <span v-if="col.format=='alert' && record[col.name]" class="icon"><i class="fas fa-bell"></i></span>
                  {{ filter( getFieldValue(record, col.fieldname), col.format ) }}
                </span>

              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- versione cards -->
  
    <nav class="level" v-if="$store.state.busy">
      <div class="level-item has-text-centered">
        <button class="button is-loading" >Loading</button>
      </div>
    </nav>
    <bulmaPagination v-if="!$store.state.busy && !config.simpleTable" v-bind:maxPages="maxPages" v-bind:currentPage="currentPage"  v-on:goto="loadPage" v-on:next="loadNextPage" v-on:previous="loadPreviousPage"></bulmaPagination>
 
    <div v-if="isAdmin() && getEditProps">
      <bulmatableprops
        v-if="showModal"
        v-bind:config="config"
        v-bind:id="id"
        v-on:change="closeModal"
        v-on:close="closeModal"
        v-on:refresh="updateTable"
      ></bulmatableprops>
   
      <button class="button" v-on:click="changeShowModal()">
        <span class="icon is-small">
          <i class="fas fa-pen"></i>
        </span>
        <span>Table</span>
      </button>
    </div>
    

  </div>
  <div v-else-if="!hasConfig && isAdmin() && getEditProps"> 
    <bulmatableprops
      v-if="showModal"
      v-bind:config="config ? config : {}"
      v-bind:id="id"
      v-on:change="closeModal"
      v-on:close="closeModal"
      v-on:refresh="updateTable"
    ></bulmatableprops>
    <button class="button" v-on:click="changeShowModal()">Initialise Table</button>
  </div>

  </div>
</template>

<script>
/* { "id":"id", "label":"Key", "fieldname":"Id", "format": "hidden", },*/

import numeral from 'numeral'
import moment from 'moment'
import bulmatableprops from '../components/bulma_tableprops.vue'

export default {
  name: 'bulmaTable',
  components: {
    bulmatableprops
  },
  props: {
    id: String,
    data: Object,
    disabledProp: Boolean,
    wrapheader: Boolean,
    wrapcell: Boolean,
  },
  data: function () {
    return {
      current_list: {},
      current_list_name:'',

      records: [],
      currentPage: 1,
      // nrecbypage: 8
      // nrecbypageDesktop: 8,

      selected_list_id:[],
      checkedAllOptions: false,
      variabile: '',

      showInput: false,
      inputSearch: '',
      searchFilter: '',
      searchDelay: '',

      showFiltri: false,
      orderingColumn: '',
      sortingAsc: true,

      showInputFilter: false,
      inputFilter: '',
      columnFilter: {},
      showModal: false,
      showModal2: false,

      large_screen: true,

      // setTableCard: true,
      setTableColumnFix: false
    }
  },
  watch: {
    broadcast_message: function(newVal) { // bus message
      if (newVal && newVal.message) {
        console.log('broadcast_message:', this.broadcast_message);
        if (this.broadcast_message.message=='refresh') {
          this.loadRows();
        }
      }
    },
    id: function(newVal, oldVal) {
      if(newVal != oldVal) this.loadComponentData()
    },
    '$store.getters.getRecordData': function(newVal, oldVal) {
      console.log('watcher getRecordData', newVal, oldVal)
      if((newVal && !oldVal) || (oldVal && newVal && newVal.Id != oldVal.Id)) this.loadRows()
    },
    myprofile() {
      const visible = this.listviews;
      if (!visible || visible.length === 0) return;
      const currentVisible = visible.find(l => l.name === this.current_list_name);
      if (!currentVisible) {
        const fallback = visible.find(l => l.default) || visible[0];
        if (fallback) {
          this.current_list = fallback;
          this.current_list_name = fallback.name;
          this.$store.commit('SET_TABLE_INDEX', { table: this.id, list: this.current_list_name });
          this.$store.commit('SET_TABLE_INDEX', { table: this.id, page: 1 });
          this.currentPage = 1;
          this.loadRows();
        }
      }
    }
  },
  computed: {
    setTableCard: function() {
      if (this.current_list)
        return this.current_list.setTableCard || false;
      return false;
    },
    canInsert: function() {
      const base = !!(this.config && this.config.caninsert);
      if (!base) return false;

      const guard = this.config.disableInsertWhen || this.config.insertGuard;
      if (!guard) return base;

      const parentRecord = this.$store.getters.getRecordData;
      if (!parentRecord) return base;

      const conditions = Array.isArray(guard) ? guard : [guard];
      const isDisabled = conditions.some(c => this._matchCondition(parentRecord, c));
      return !isDisabled;
    },
    broadcast_message: function() { // bus message
      return { message: this.$store.state.broadcast_message, payload :this.$store.state.broadcast_message_payload };
    },
    nrecbypage() {
      return this.config.nrecbypage || 10
    },
    nrecbypageDesktop() {
      return this.config.nrecbypageDesktop || 20
    },
    current_page_records: function() {
      JSON.stringify(this.records)
      let s=(this.currentPage-1)*this.nrecbypage;
      let e = s + this.nrecbypage
      return this.records.slice(s,e);
    },
    current_page_records_desktop: function() {
      let s=(this.currentPage-1)*this.nrecbypageDesktop;
      let e = s + this.nrecbypageDesktop
      return this.records.slice(s,e);
    },
    current_list_cols: function() {
      if (!this.current_list || !this.current_list.cols) return this.current_list;
      return this.current_list.cols.filter( (c) => { return c.format!='hidden'; } )
      var cols = this.current_list.cols.filter( (c) => { return c.format!='hidden'; } )
      return cols.slice(0, 3)
    },
    maxPages: function() {
      let res=this.$store.getters.getRecordsList(this.id);
      if (res) {
        if(!this.large_screen) return Math.ceil(res.totalRecords/this.nrecbypage);
        else return Math.ceil(res.totalRecords/this.nrecbypageDesktop);
      }
      return 0;
    },
    config: function() {
      return this.$store.getters.getObject(this.id).data;
    },
    checkedAll() {
      if(this.selected_list_id.length == this.current_page_records.length) return true
      if(this.checkedAllOptions) return true
      return false
    },
    lookup_process() {
      return this.config.lookup_process;
    },
    numCols() {
      return ( 'is-' + Math.floor( 12 / (this.current_list_cols.length - 1) ) )
    },
    current_cols_map() {
      var map = {}
      for(var c of this.current_list_cols) { map[c.fieldname] = c }
      return map
    },
    changeEditMode(){
      var newEditStatis = !this.$store.getters.getEditMode(this.id)
      var payload={ id: this.id, editmode: newEditStatis};
      this.$store.commit('SET_EDITMODE', payload);
    },
    getEditProps(){
      return this.$store.getters.getEditProps;
    },
    searchableFields: function () {
      if(this.config && this.config.searchSection) {
        if (!this.$store.state.database.has(this.config.table)) return [];
        let solvedfields=[]
        this.config.searchSection.forEach( s => {
          var solvedSection = []
          var table = this.$store.state.database.get(s.table)
          s.searchableColumns.forEach( f => {
            if (table.has(f.fieldname)) {
              if(table.get(f.fieldname).type != 'hidden') {
                let f2={ ...table.get(f.fieldname) }
                f2['table'] = s.table
                solvedSection.push( f2 );
              }
            }
          })
          solvedfields.push(solvedSection)
        })
        return solvedfields;
      }
    },
    hasConfig() {
      //return this.config && 'actions' in this.config;
      if(this.config) return true
      return false
    },
    listviews() {
      var lists = []
      for (var l of this.config.lists) {
        let visibleByProfile = true
        let visibleByApps = true

        if (l.profileVisibility && l.profileVisibility.length > 0) {
          const profile = this.$store.state.myprofile && this.$store.state.myprofile.Salespaddy_profile__c
          visibleByProfile = !!profile && l.profileVisibility.includes(profile)
        }

        if (l.apps && Array.isArray(l.apps) && l.apps.length > 0) {
          const myprofile = this.$store.state.myprofile
          // TODO so... actually someone expects myprofile.teams
          if (!myprofile || !myprofile.teams || myprofile.teams.length === 0) {
            visibleByApps = false
          } else {
            visibleByApps = myprofile.teams.some(team => {
              const app = team.Team__r && team.Team__r.App_abilitata__c
              return app && (l.apps.includes(app) || l.apps.includes('default'))
            })
          }
        }

        if (visibleByProfile && visibleByApps) lists.push(l)
      }
      return lists
    },
    myprofile() {
      return this.$store.state.myprofile
    }
  },
  mounted: function() {
    console.log('---------- MOUNTED TABLE!!!!!!!!')
    if(this.$store.state.tableindexes[this.id] && this.$store.state.tableindexes[this.id].page){
        this.currentPage = this.$store.state.tableindexes[this.id].page;
        console.log("current page recuperata ", this.currentPage, typeof(this.currentPage))
    }else {
      this.$store.commit('SET_TABLE_INDEX', {table: this.id, page: 1});
       this.currentPage = 1;
       console.log("current page 1")

    }
    this.loadComponentData()
    if(this.config && this.config.searchSection) this.$store.commit('SET_RECORDS_STATE',{ id: this.config.process, state: 'SEARCH'})

    let mq=window.matchMedia("(max-width: 1100px)");
    if (mq && mq.matches) {
      this.large_screen=false;
    }
  },
  methods: {
    loadComponentData() {
      if(!this.hasConfig) return

      // current list: usa listviews (filtrate) invece di config.lists
      const visible = this.listviews;
      if (!visible || visible.length === 0) return;

      if (this.$store.state.tableindexes[this.id] && this.$store.state.tableindexes[this.id].list) {
        this.current_list = visible.find(l => l.name === this.$store.state.tableindexes[this.id].list);
        console.log("spottato");
      } else {
        this.current_list = visible.find(l => l.default) || visible[0];
        console.log("no memory");
      }

      if (!this.current_list || !this.current_list.name) return;

      this.$store.commit('SET_TABLE_INDEX', {table: this.id, list: this.current_list.name});
      this.current_list_name = this.current_list.name;

      if (this.config.nrecbypage) this.nrecbypage = this.config.nrecbypage;

      if (this.config.checkbox) {
        if (this.config.checkbox == 'multi') this.selected_list_id.push(this.$store.state.lookup_field_value)
        else this.selected_list_id = this.$store.state.lookup_field_value
      }
      console.log('this.selected_list_id', this.selected_list_id)

      this.current_list.cols.forEach(c => {
        c['sorting'] = ''
        c['filtering'] = false
      })

      // hydration
      if (this.config.hydration) {
        this.hydrate();
      } else {
        this.loadRows();
      }
    },
    resetAdvancedFilters() {
      this.$store.commit('CLEAR_ADVANCEDFILTERINGPROPERTIES')
      this.loadRows()
    },
    isActionable: function(type) {
      if (type=='email') return true;
      if (type=='phone') return true;
      return false;
    },
    toggleSearch: function() {
      this.showInput = !this.showInput;
      if (!this.showInput) { // reset filter
        this.searchFilter='';
        this.inputSearch='';
        this.changeList();
      }
    },
    localAction: function(action) {
      switch (action.action) {
        case 'new_record':
          this.create();
          break;
        case 'search_record':
          this.search();
        break;
        case 'reload_records':
          this.loadRows();
        break;
      }
    },
    changeList: function() {
      console.log("changeList", this.current_list_name);
      this.current_list=this.config.lists.find( (l) => { return this.current_list_name==l.name; });
    
      this.$store.commit('SET_TABLE_INDEX', {table: this.id, list: this.current_list_name});
      this.$store.commit('SET_TABLE_INDEX', {table: this.id, page: 1});
      this.currentPage = 1;
      console.log("current_list", this.current_list);

      this.loadRows();
    },
    create: function() {
      // new_record
      let m={ message: 'new_record', payload: this.config.process};
      this.$store.commit('POST_MESSAGE', m);
    },
    search() {
      console.log('--> search')
      if (this.searchDelay) clearTimeout(this.searchDelay);
      this.searchDelay=setTimeout( () => {
        
        this.searchFilter={
          fieldname: this.columnFilter[0] ? this.columnFilter[0].fieldname : (this.config.searchKey ? this.config.searchKey : 'Name'),
          operator: 'LIKE',
          value: this.columnFilter[0] ? this.inputFilter : this.inputSearch.replaceAll(" ","%")
        }
        this.showInputFilter = false
        console.log('this.searchFilter',this.searchFilter)
        this.loadRows()
      },500)
    },
    selectColumnSortOrder() {
      var col = this.current_list_cols.find( c => c.fieldname == this.orderingColumn )
      if(col) {
        if(col.sorting == 'down') col.sorting = ''
        this.sortOrder(col)
      } else this.changeList()
    },
    sortOrder(col) {
      console.log('-> sortOrder', col)
      // this.sortingAsc = !this.sortingAsc
      this.current_list.cols.forEach( c => { if(c.id != col.id) c.sorting = '' })
      switch (col.sorting) {
        case '':
          col.sorting = 'up'
          this.sortingAsc = true
          this.orderby(col.fieldname)
          break
        case 'up':
          col.sorting = 'down'
          this.sortingAsc = false
          this.orderby(col.fieldname)
          break
        case 'down':
          col.sorting = ''
          this.changeList()
          break
      }
    },
    orderby(column) {
      console.log('F --> orderby')
      // var column = this.orderingColumn
      console.log('column',column)

      // INDIVIDUA VALUES
      if(column.includes('.')) var parentAndField = column.split('.')
      var containsNum = false

      var infos = []
      for(var r of this.records) {
        for(var f of Object.keys(r)) {
          // console.log(f, column, f == column)
          // console.log(column.includes('.'), f, parentAndField)
          if(f == column) {
            infos.push(r[f] && typeof r[f] === 'string' ? r[f].toUpperCase() : r[f])
            if(typeof(r[f]) == 'number') containsNum = true
            break
          } else if( column.includes('.') && f == parentAndField[0] ) {
            var info = r[parentAndField[0]][parentAndField[1]]
            infos.push(info && typeof info === 'string' ? info.toUpperCase() : info)
            if(typeof(info) == 'number') containsNum = true
            break
          }
        }
      }
      console.log('infos',infos)

      // SORT VALUES
      console.log('sort')
      infos = infos.sort()
      if(containsNum) infos.sort(function(a, b){return a-b})
      if(!this.sortingAsc) {
        console.log('reverse')
        infos = infos.reverse()
      }
      console.log('infos ', infos)

      // SHOW SORTED VALUES
      let recordsNotSorted = this.records
      this.records = []

      var identifiers = []
      for(var i of infos) {
        for(var r of recordsNotSorted) {
          for(var f of Object.keys(r)) {
            var identifier
            if(r.Id) identifier = r.Id
            else console.log('manca identifier nel record',r)

            var col = column
            var info = r[f]

            if(column.includes('.')) {
              col = parentAndField[0]
              info = r[parentAndField[0]][parentAndField[1]]
            }

            if(info && typeof info === 'string') info = info.toUpperCase()
            if(f == col && i == info && r.show && !identifiers.includes(identifier)) {
              this.records.push(r)
              identifiers.push(identifier)
            }

          }
        }
      }
    },
    canFilter(format) {
      switch(format) {
        case 'number':
        case 'currency':
        case 'address':
        case 'download':
        case 'date': case 'datetime':
          return false
        default:
          return true
      }
    },
    showFilterPopUp(col) {
      console.log('--> filterRows on', col)
      this.inputFilter = ''

      // TODO: basta farsi passare l'indice per evitare questo scempio
      const updatedCols = this.current_list.cols.map(c => {
        return { ...c, filtering: !col.filtering && c.id === col.id ? true :  false };
      });
      this.current_list.cols = updatedCols;

      if(!col.filtering) {
        this.showInputFilter = true
      // TODO: basta farsi passare l'indice per evitare questo scempio
      this.columnFilter = this.current_list.cols.filter( (c) => { return c.id === col.id } )
      } else {
        this.showInputFilter = false
        this.searchFilter = ''
        this.columnFilter = {}
        this.loadRows()
      }
    },
    loadNextPage: async function() {
      this.currentPage++;
      this.$store.commit('SET_TABLE_INDEX', {table: this.id, page: this.currentPage});
    },
    loadPreviousPage: async function() {
      this.currentPage--;
      this.$store.commit('SET_TABLE_INDEX', {table: this.id, page: this.currentPage});
    },
    loadPage: async function(p) {
      this.currentPage=p;
      this.$store.commit('SET_TABLE_INDEX', {table: this.id, page: this.currentPage});
    },
    loadRows: async function() {
      if(!this.config) return;
      console.log('--> loadRows (bulma_table)')
      this.records=[];
      this.currentPage = 1

      let f=[ ... this.current_list.filters]
      if(this.$store.getters.getRecordState == 'NEW') {
        this.current_list.filters.forEach( filtro => {
          f.push({ fieldname: filtro.fieldname, operator: "NO_STRING_NEQ", value: 'null' })
        })
      }
      console.log('f',f)

      if (this.searchFilter) f=f.concat(this.searchFilter);

      var advancedFilters = []
      if (this.config && this.config.searchSection && this.$store.state.advancedFilteringProperties.length > 0) {
        this.config.searchSection.forEach( s => {
          if(s.table == this.config.table) {
            f = f.concat(this.$store.state.advancedFilteringProperties.filter( f => f.table == s.table ))
          } else {
            var filters = this.$store.state.advancedFilteringProperties.filter( f => f.table == s.table )
            if(filters.length) {
              advancedFilters.push({
                parentKey : s.parentKey,
                tablename : s.table,
                filters : filters
              })
            }
          }
        })
      }
      console.log('advancedFilters',advancedFilters, advancedFilters.filters)

      if(this.current_list.childQuery) this.current_list.childQuery.forEach( cq => { advancedFilters.push( cq ) })

      var payload={
        id: this.id,
        tablename: this.config.table,
        cols: this.current_list.cols,
        filters: f,
        childQuery: advancedFilters.length ? advancedFilters : [],
        orders: this.current_list.order,
        offset: 0,
        limit: this.current_list.limit ? this.current_list.limit : 16
      }
      console.log('PAYLOAD', payload)

      await this.$store.dispatch('load_records', payload );

      let data=this.$store.getters.getRecordsList(this.id);
      if (data) {
        console.log('data',data)
        this.records=data.records
        if(this.orderingColumn) this.orderby()
      }
    },
    // TODO: hydrate is for hubspot, currently broken :)
    hydrate: async function() {
      this.records=[];

      let records=this.$store.getters.getRecordAssoc(this.config.table);
      this.$store.commit('SET_RECORDS_DATA', { id:this.id, data:records});
      let p=[];
      this.config.cols.forEach( f => {
        if (f.fieldname!='id') p.push(f.fieldname);
      });

      let res=await this.$store.dispatch('hydrate_records', { id: this.id, object: this.config.table, properties:p});
      if (res.data) {
        res.data.results.forEach( (r) => {
          r.properties.id=r.id;
          this.records.push(r.properties);
        })
      }
    },
    getDateFormat: function(includeTime = false) {

      //console.log("this.$clientConfig --> ",this.$clientConfig);
      //console.log("this.$clientConfig.dateFormat --> ",this.$clientConfig.dateFormat);
       const base = (this.$clientConfig && this.$clientConfig.dateFormat) || 'DD/MM/YYYY';
       return includeTime ? `${base} HH:mm` : base;

    },
  filter: function(v, type) {
      if (!v && v !== false) return v;

      let formato = ''
      let formatoFinale = ''
      // TODO: locale
      switch(type) {
        case 'hidden':
          return;
        case 'date':
          if (v) {
            var d = new moment(v);
            return d.format(this.getDateFormat(false));
          }
          return v;
        case 'datetime':
          if (v) {
            var dt = new moment(v);
            return dt.format(this.getDateFormat(true));
          }
          return v;
        case 'number':
            return numeral(v).format('0,0.00')
        case 'decimal':
          return numeral(v).format('0,0.[0000]');
        case 'currency':
          /*
          if(this.config.numberOfDecimals || this.config.numberOfDecimals==0) {
            formato = '€ 0.0,' + formato.padEnd(this.config.numberOfDecimals+formato.length, "0")
          } else formato = '€ 0.0,00'
          return numeral(v).format(formato);
          // return numeral(v).format('$ 0,0.00');
          */
         return numeral(v).format('€ 0,0.00');
        case 'percentage':
          if(this.config.numberOfDecimals || this.config.numberOfDecimals==0) {
            formato = '0.' + formato.padEnd(this.config.numberOfDecimals+formato.length, "0")
          } else formato = '0.00'
          return numeral(v).format(formato+'%');
          // return numeral(v).format('0.00%')
        case 'alert':
          return '';
        case 'phone':
          return 'tel:'+v;
        case 'email':
          return 'mailto:'+v;
        case 'truncate':
            return v.substr(0,32);
        case 'comment':
          return '';
        case 'checkbox':
          return v;
      }
      return v;
    },
    getAddress(value) {
      if(!value) return ''

      var street = ''
      if(value.street) street = value.street
      if(value.city) street += ' '+value.city
      if(value.state) street += ' '+value.state
      if(value.postalCode) street += ' '+value.postalCode

      return street

    },
    inOneLine(type) {
      switch(type) {
        case 'currency': case 'phone':
          return true
      }
    },
    getFieldValue: function(obj, path) {
      // eslint-disable-next-line no-redeclare
      for (var i=0, path=path.split('.'), len=path.length; i<len; i++){
        if (obj)
          obj = obj[path[i]];
      }
      return obj;
    },
    align: function(type) {
      switch(type) {
        case 'currency': case 'decimal': case 'number':
          return 'right';
      }
      return 'left';
    },
    select: function(record, col) {
      console.log('select: ', record, col)

      // if(this.lookup_process) this.showEdit(record)
      // TODO: da attivare prima della messa in prod
      if(col.format == 'lookup') this.showEdit(record)
      else { // col.format == 'link'
        let id=col.link_fieldname;
        var path = this.getLinkPath(record[id])
        this.$router.push(`/${path}/d/${record[id]}`);
      }
    },
    getLinkPath(id) {
      var idStart = id.slice(0,3)
      var process = this.$store.state.config.processes.find( obj => obj.recordStartWith == idStart )
      return process.id
    },
    showEdit(record) {
      console.log('--> showEdit', record);
      delete record.show

      var verb = this.$store.getters.getVerb( this.$store.getters.getProcess(this.lookup_process), 'e' )
      //recupero la page associata
      var page = this.$store.getters.getPage( verb.pageid )
      console.log("--> showEdit, page: ", page);


      var data = {
        processId: this.lookup_process,
        verbId: "e",
        //utilizzo il componente associato alla page
        title: this.$store.getters.getObject(page.initialid).data.title,
        candelete: this.config.candelete,
        table: this.config.table
      }
      console.log('data',data)
      this.$store.commit('PUSH_PROCESS_STATUS', data);
      this.$store.commit('SET_RECORDS_STATE', {id: this.lookup_process, state:'EDIT'});
      this.$store.commit('SET_RECORDS_DATA', {id: this.lookup_process, data: record });
    },
    selectAll(checkedAll) {
      console.log(checkedAll)
      this.selected_list_id = []
      if(!checkedAll) {
        for(var r of this.current_page_records) {
          // this.selected_list_name.push(r[this.config.Id.fieldname])
          this.selected_list_id.push(r.Id)
        }
        this.saveRecords()
      }
    },
    showAddRecord() {
      console.log('--> showAddRecord');
      
      // Evita l'inserimento se disabilitato dallo stato del padre
      if (!this.canInsert) {
        console.warn('Insert disabilitato dallo stato del record padre/config');
        return;
      }

      let pid=this.config.lookup_process;
      if (!pid) {
        if(this.config.process != this.$store.state.global_state_process) this.$store.commit('SET_GLOBAL_STATE_PROCESS', this.config.process)
        this.$store.commit('SET_RECORDS_ID', { id: this.$store.state.global_state_process, data: ''})
        if(this.config.defaults) this.$store.commit('SET_GLOBAL_STATE_DEFAULTS', this.config.defaults)
        this.create();
        // this.$router.push(this.config.path.create);
        return;
      }
      var data = {
        processId: this.config.lookup_process,
        verbId: "n",
        title: this.config.title,
        table: this.config.table,
        defaults: this.config.defaults
      }
      this.$store.commit('PUSH_PROCESS_STATUS', data);
      this.$store.commit('SET_RECORDS_STATE', {id: this.config.lookup_process, state:'NEW'});
      this.$store.commit('SET_RECORDS_DATA', {id: this.config.lookup_process, data:{}});
    },
    showAddRecordOld() {
      console.log('--> showAddRecord');

      var object = this.$store.getters.getObject(this.config.addForm.id)
      var data = {
        id: this.config.addForm.id,
        title: object.data.title,
        type: object.type
      }
      this.$store.commit('POST_MESSAGE', { message: 'goto_search', payload: data} );
      // this.$store.commit('SET_RECORDS_STATE', {id: this.$store.state.global_state_process, state:'NEW'});
      this.$store.commit('SET_RECORDS_STATE', {id: this.config.addForm.id, state:'NEW'});
      this.$store.commit('SET_RECORDS_DATA', {id: this.config.addForm.id, data:{}});
    },
    saveRecords(record) {
      console.log('saveRecords', record)
      this.selected_list_id = record.Id
      this.$store.commit('SET_PROCESS_STATUS_DATA', {
        name: 'selected_id',
        value: record.Id,
      });
      this.$store.commit('SET_PROCESS_STATUS_DATA', {
        name: 'selected_name',
        value: record.Name,
      });
      // Salva anche l'intero record selezionato per propagazioni generiche
      this.$store.commit('SET_PROCESS_STATUS_DATA', {
        name: 'selected_record',
        value: record,
      });

      this.$store.commit('SET_CONVERT_HINT', { id: this.id, type: 'id', value: record.Id })
      this.$store.commit('SET_CONVERT_HINT', { id: this.id, type: 'related', value: record.Name })

/*
      if(!this.$store.getters.getRecordData.length) {
        var status = this.$store.getters.getProcessStatus;
        var config = this.$store.getters.getProcess(status.processId);

        var data = {}
        var fields = this.$store.state.database.get(config.table)
        console.log('fields',fields)
        fields.forEach( f => {
          console.log(f.name, record[f.name])
          if(!f.readonly) data[f.name] = record[f.name]
        });
        var defaults = this.$store.getters.getVerb(config, status.verbId).defaults
        if(defaults != undefined) {
          console.log('defaults')
          defaults.forEach( d => {
            var defaultField = d.default.split('.')[1]
            var value = ''
            switch (d.default.split('.')[0]) {
              case '$previous':
                value = this.$store.state.records_data[this.$store.state.global_state_process][defaultField]
                break
              default:
                value = d.default
            }
            console.log('value',value)
            data[d.fieldname] = value
          })
        } 
        console.log('data: ', data)
        this.$store.commit('SET_RECORDS_DATA', {id: status.processId, data: data});
      }
*/
      // al momento solo per la single select
      /*
      var r = this.$store.getters.getRecordData
      r[this.$store.state.lookup_field] = this.selected_list_id
      this.$store.commit('SET_RECORDS_DATA', r);
      */
    },
    _getNestedValue(obj, path) {
      if (!obj || !path) return undefined;
      if (path.includes('.')) {
        return path.split('.').reduce((acc, key) => acc && acc[key], obj);
      }
      return obj[path];
    },
    _matchCondition(record, cond) {
      const field = cond.fieldname || cond.field;
      const operator = cond.operator || 'EQ';
      const expected = cond.value;
      const actual = this._getNestedValue(record, field);

      if (actual === undefined || actual === null) return false;

      switch (operator) {
        case 'EQ': return actual === expected;
        case 'NEQ': return actual !== expected;
        case 'IN': {
          if (!Array.isArray(expected)) return false;
          const actualStr = String(actual).trim().toLowerCase();
          const expectedStrs = expected.map(v => String(v).trim().toLowerCase());
          return expectedStrs.includes(actualStr);
        }
        case 'NOT_IN':
        case 'NIN': {
          if (!Array.isArray(expected)) return false;
          const actualStr = String(actual).trim().toLowerCase();
          const expectedStrs = expected.map(v => String(v).trim().toLowerCase());
          return !expectedStrs.includes(actualStr);
        }
        case 'NO_STRING_EQ': return String(actual) === String(expected);
        default: return actual === expected;
      }
    },
    isAdmin(){
      return this.$store.getters.isAdmin;
    },
    changeShowModal(){
      this.showModal=!this.showModal;
    },
    closeModal(){
      this.showModal=false;
    },
    updateTable(){
      console.log("--> updateTable")
      let m={ message: 'refresh'};
      this.$store.commit('BROADCAST_MESSAGE', m);
      this.showModal=false;
    },
    async download(value, record) {
      console.log('value',value)
      let res = await this.$store.dispatch('get_content_body', {uri: value});
      var hrefFile = 'data:application/pdf;base64,' + res.data.body;

      var a = document.createElement("a");
      a.setAttribute('href', hrefFile);
      a.setAttribute('download', record.Title);
      a.setAttribute('target', '_blank');
      a.click();
      // console.log(res);
      // console.log(hrefFile);
    },
    openCard(record) {
      console.log('openCard')
      var r = this.records.find( r => r.id == record.id )
      if(r.showContent == undefined) r['showContent'] = true
      else r.showContent = !r.showContent
      console.log(this.records[0])
    },
  }
}
</script>

<style scoped>
.rowcard {
  border-bottom: 1px;
  border-bottom-style: groove;
  border-bottom-color: #00000080;
}

.labelcard {
  font-size: 10px;
}

th.filterhover:hover span.hiddenicon {
  display: inline-flex;

}
.hiddenicon {
  display: none;
  font-family: 14px;
}

.bloccato {
  position: sticky;
  top: 0;
  z-index: 1;
}
.is-text-overflow {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.is-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
}
/* table tr td:first-child, table tr th:first-child { */
.first-column-fix {
  position: sticky;
  left: 0;
  background: var(--bulma-scheme-main);
}
/* div.column:hover span.icon {
  display
} */
</style>